/**
 * LTI Enrollment Classes
 * LTI Enroll Class for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';

/**
* EventDetail service.
* @module api/EventDetailApi
* @version 2.0.0
*/
export default class EventDetailApi {

    /**
    * Constructs a new EventDetailApi. 
    * @alias module:api/EventDetailApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get exam Buildings
     * @param {Number} formativeAction 
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    enrollmentClassesControllerGetClassesBuildingsWithHttpInfo(formativeAction, studentId) {
      let postBody = null;
      // verify the required parameter 'formativeAction' is set
      if (formativeAction === undefined || formativeAction === null) {
        throw new Error("Missing the required parameter 'formativeAction' when calling enrollmentClassesControllerGetClassesBuildings");
      }
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollmentClassesControllerGetClassesBuildings");
      }

      let pathParams = {
        'formative_action': formativeAction,
        'student_id': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/lti/enrollmentClasses/buildings/formative_action/{formative_action}/students/{student_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get exam Buildings
     * @param {Number} formativeAction 
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    enrollmentClassesControllerGetClassesBuildings(formativeAction, studentId) {
      return this.enrollmentClassesControllerGetClassesBuildingsWithHttpInfo(formativeAction, studentId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get shedules cancel class
     * @param {Number} studentId 
     * @param {Number} eventId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    enrollmentClassesControllerGetShedulesCancelClassWithHttpInfo(studentId, eventId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollmentClassesControllerGetShedulesCancelClass");
      }
      // verify the required parameter 'eventId' is set
      if (eventId === undefined || eventId === null) {
        throw new Error("Missing the required parameter 'eventId' when calling enrollmentClassesControllerGetShedulesCancelClass");
      }

      let pathParams = {
        'student_id': studentId,
        'event_id': eventId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/lti/enrollmentClasses/cancel_shedules/student/{student_id}/event/{event_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get shedules cancel class
     * @param {Number} studentId 
     * @param {Number} eventId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    enrollmentClassesControllerGetShedulesCancelClass(studentId, eventId) {
      return this.enrollmentClassesControllerGetShedulesCancelClassWithHttpInfo(studentId, eventId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get shedules exam
     * @param {Number} studentId 
     * @param {Number} buildingId 
     * @param {Number} formativeActionId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    enrollmentClassesControllerGetShedulesClassesWithHttpInfo(studentId, buildingId, formativeActionId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollmentClassesControllerGetShedulesClasses");
      }
      // verify the required parameter 'buildingId' is set
      if (buildingId === undefined || buildingId === null) {
        throw new Error("Missing the required parameter 'buildingId' when calling enrollmentClassesControllerGetShedulesClasses");
      }
      // verify the required parameter 'formativeActionId' is set
      if (formativeActionId === undefined || formativeActionId === null) {
        throw new Error("Missing the required parameter 'formativeActionId' when calling enrollmentClassesControllerGetShedulesClasses");
      }

      let pathParams = {
        'student_id': studentId,
        'building_id': buildingId,
        'formative_action_id': formativeActionId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/lti/enrollmentClasses/shedules/student/{student_id}/building/{building_id}/formative_action/{formative_action_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get shedules exam
     * @param {Number} studentId 
     * @param {Number} buildingId 
     * @param {Number} formativeActionId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    enrollmentClassesControllerGetShedulesClasses(studentId, buildingId, formativeActionId) {
      return this.enrollmentClassesControllerGetShedulesClassesWithHttpInfo(studentId, buildingId, formativeActionId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
